import { render, staticRenderFns } from "./ReporteDinamico.vue?vue&type=template&id=a070b210"
import script from "./ReporteDinamico.vue?vue&type=script&lang=js"
export * from "./ReporteDinamico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports